<template>
  <div class="character-item">
    <ImageView class="image" :src="image" placeholder="/img/placeholders/character.png" />
    <div>
      <div class="role">{{ $t('characterItem.roleLabel') }}{{ role }}</div>
      <div class="name">{{ name }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import ImageView from "@/components/atoms/ImageView.vue";
import { Character } from "@/lib/models";
import { getCharacterKey } from "@/lib/s3";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ImageView },
  props: {
    novelId: String,
    character: Object as PropType<Character>,
  },
  computed: {
    name() {
      return this.character.name;
    },
    role() {
      const role = this.character.detail.find((detail) => detail.name === "role");
      return role ? role.value : "-";
    },
    image() {
      return getCharacterKey(this.novelId, this.character);
    },
  },
});

interface Props {
  novelId: string;
  character: Character;
}

interface Data {}

interface Computed {
  name: string;
  role: string;
  image: any;
}

interface Methods {}
</script>

<style lang="scss" scoped>
.character-item {
  display: flex;
  align-items: center;

  .image {
    flex-shrink: 0;
    height: 50px;
    width: 50px;
    margin-right: 20px;
    box-sizing: border-box;
    border: solid 0.5px rgb(169, 169, 169);
    border-radius: var(--radius-circle);
  }

  .role {
    color: var(--color-text-low);
    font-weight: var(--font-weight-bold);
    margin-bottom: 0.5em;
  }

  .name {
    font-weight: var(--font-weight-bold);
    font-size: 1.1em;
  }
}
</style>
